import axios from 'axios'

const default_metadata = {
  'ean': undefined,
  'grade': undefined,
  'metadataUrl': undefined,
  'site': undefined,
  'subject': undefined,
  'program': undefined,
  'aunivers': {
    'inDevelopment': undefined,
    'locationId': undefined,
    'thumbnailUrl': undefined,
    'thumbnailColor': undefined,
    'remoteId': undefined,
    'design': undefined,
    'externalUrl': undefined,
    'name': undefined,
    'thumbnailAlt': undefined,
    'redirectLocation': undefined
  }
}

const state = {
  metadata: { ...default_metadata }
}

const mutations = {
  UPDATE_METADATA (state, payload) {
    state.metadata = payload
  }
}

const actions = {
  getMetadata ({ commit }, params) {
    axios
      .get(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/metadata/' + params.ean, {
        params: {
          preferredLanguage: params.preferredLanguage
        }
      })
      .catch(error => {
        commit('UPDATE_METADATA', default_metadata)
        error.ignore = true
        throw error
      })
      .then((response) => {
        if (response.data) {
          commit('UPDATE_METADATA', response.data)
        }
      })
  },
  resetMetadata ({ commit }) {
    commit('UPDATE_METADATA', { ...default_metadata })
  }
}

const getters = {
  metadata: state => state.metadata,
}

const metadataModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default metadataModule
